import type { Camera } from './api';

/**
 * Pencocokan kotak pencarian kamera: nama, host, path, dan catatan — tanpa
 * peduli besar-kecil huruf.
 *
 * Duduk di `lib/` dan bukan di salah satu halaman karena dipakai dua tempat:
 * `/cameras` dan bilah dashboard (24 Agustus 2026). Keduanya memasang
 * placeholder yang sama, dan kotak yang berbunyi sama wajib mencari hal yang
 * sama juga — sampai revisi ini dashboard diam-diam hanya mencocokkan nama.
 */
export function cocokKamera(c: Camera, q: string): boolean {
  if (q === '') return true;
  const t = q.toLowerCase();
  return (
    c.name.toLowerCase().includes(t) ||
    // `host` tidak dikirim ke viewer (§F6) — yang tidak diterima tidak bisa
    // dicari, dan itu jawaban yang benar, bukan kegagalan.
    (c.host ?? '').toLowerCase().includes(t) ||
    c.mainPath.toLowerCase().includes(t) ||
    (c.subPath?.toLowerCase().includes(t) ?? false) ||
    // Catatan ikut dicari (§G11, 8 Sep 2026). Justru ini yang membuat catatan
    // berguna melampaui kamera yang sedang dilihat: mengetik "lantai 2" atau
    // nama pemiliknya menemukan seluruh kamera yang menyangkut hal itu, dan
    // tanpa pencarian catatan cuma bisa dibaca satu per satu.
    (c.remarks?.toLowerCase().includes(t) ?? false)
  );
}
